import React from "react";
import Modal from "react-responsive-modal";
import { Button, Label, Input } from "../../revvComponents";

class ManageColumnsPopup extends React.Component {
  state = {
    manageColumns: [...this.props.columns],
    removedHeaders: [],
    connectedDataSource: "",
    viewMode: "",
  };

  componentDidMount() {
    let columnHeaders = [];
    let removedHeaders = [];
    let { columnDefs } = this.props;
    const { component } = this.props;
    if (
      component &&
      component.data &&
      component.data.attributes &&
      component.data.attributes.dataSource === "DealTable" &&
      component.data.attributes.viewMode !== "GROUP_SUMMARY_VIEW" &&
      Array.isArray(columnDefs) &&
      columnDefs.length > 0
    ) {
      this.setState({
        connectedDataSource: component.data.attributes.dataSource,
        viewMode: component.data.attributes.viewMode
          ? component.data.attributes.viewMode
          : "NORMAL_VIEW",
      });
      columnDefs = columnDefs.filter(col => col.hidden !== true);
      const requiredHeaders = [];
      columnDefs.forEach(def => requiredHeaders.push(def.headerName));
      columnHeaders = this.state.manageColumns.filter(col =>
        requiredHeaders.includes(col.name),
      );
      removedHeaders = this.state.manageColumns.filter(
        col => !requiredHeaders.includes(col.name),
      );
      this.setState({
        manageColumns: [...columnHeaders],
        removedHeaders: [...removedHeaders],
      });
    }
    const cols = [...this.props.columns];
    let count = 0;
    cols.forEach(column => {
      if (column.show) {
        count += 1;
      }
    });
    this.setState({ checkedCount: count });
  }

  _returnTitle = () => {
    const headers = ["Columns", "Visible"];
    return headers.map(header => (
      <div className="revvtable-mngcols-header-title" key={header}>
        {header}
      </div>
    ));
  };

  _updateColumnFlag = (columnID, checkedStats, count) => {
    const { manageColumns } = this.state;
    if (checkedStats) {
      this.setState({
        checkedCount: count - 1,
      });
    } else {
      this.setState({
        checkedCount: count + 1,
      });
    }
    manageColumns[columnID].show = !checkedStats;
    this.setState({
      manageColumns,
    });
  };

  _returnColumnList = () => {
    const { manageColumns } = this.state;
    return manageColumns.map((column, index) => (
      <div className="revvtable-mngcols-row" key={column.id}>
        <div className="revvtable-mngcols-row-roles">{`${column.name}`}</div>
        <div
          className="revvtable-mngcols-row-roles"
          role="button"
          tabIndex={0}
          onKeyDown={() => {}}>
          <Label
            className="revv-inp-container is-switch"
            data-test="input-revv-inp-container-label"
            htmlFor={column.id}>
            <span
              className="revv-inp-hiddenwrapper"
              data-test="input-revv-inp-hiddenwrapper">
              <Input
                data-test="input-revv-inp-hiddenwrapper-input"
                type="checkbox"
                checked={column.show}
                onChange={() =>
                  this._updateColumnFlag(
                    index,
                    column.show,
                    this.state.checkedCount,
                  )
                }
              />
            </span>
          </Label>
        </div>
      </div>
    ));
  };

  _submit = () => {
    const hiddenColumns = [];
    const { removedHeaders, connectedDataSource, viewMode } = this.state;
    const newManageColumns = this.state.manageColumns.map(col => {
      if (col.show === false) {
        hiddenColumns.push(col.id);
      }
      return col;
    });
    if (
      connectedDataSource &&
      viewMode &&
      viewMode !== "GROUP_SUMMARY_VIEW" &&
      Array.isArray(removedHeaders) &&
      removedHeaders.length > 0
    )
      removedHeaders.forEach(col => hiddenColumns.push(col.id));
    this.props.setMngColsData(hiddenColumns, newManageColumns);
    this.props.closePopup();
  };

  render() {
    return (
      <Modal open onClose={this.props.closePopup} closeOnOverlayClick={false}>
        <div className="revv-modal-content">
          <div className="revv-modal-contenttitle">
            Manage columns visibility
            <div className="revvtable-mngcols-description">
              You can manage the visibility of the columns
            </div>
          </div>
          <div className="revvtable-mngcols-header doc-column-management">
            {this._returnTitle()}
          </div>
          <div className="revvtable-mngcols-list doc-column-management">
            <span>{this._returnColumnList()}</span>
          </div>
          <div className="revv-modal-footer">
            <div className="revv-modal-footerbtns">
              <Button
                className="btn-transparent"
                onClick={() => this.props.closePopup()}
                data-test="managecolumnspopup-discard-btn">
                Discard
              </Button>
              <Button
                disabled={this.state.checkedCount < 1}
                onClick={this._submit}
                data-test="managecolumnspopup-save-btn">
                Save
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ManageColumnsPopup;
